import { matchPath } from 'react-router-dom';

export const DEFAULT_TITLE = 'Simplify Hub';

// Each path also titles everything below it.
const PAGE_TITLES: [path: string, title: string][] = [
  ['/sro-portal', 'SRO Portal'],
  ['/api-registry', 'Simplify API Registry'],
  ['/external-health-check', 'External Health Check'],
  ['/lb-request', 'Load Balancer Request'],
  ['/haproxy-front-door', 'Haproxy Load Balancer Request'],
  ['/security-metrics', 'Security Metrics'],
  ['/github-ingestion-tracker', 'GitHub Markdown Ingestion Tracker'],
  ['/analytics', 'Analytics'],
  ['/cloud-management', 'TELUS Cloud Management'],
  ['/api-marketplace', 'API Marketplace'],
  ['/app-marketplace', 'App Marketplace'],
  ['/dashboard-library', 'Dashboard Library'],
  ['/translations-tool', 'TELUS Translator'],
  ['/telus-translator', 'TELUS Translator'],
  ['/telustranslator', 'TELUS Translator'],
  ['/gpt/copilots/e9c45e40-20f5-4aa1-9bbc-b112739037f5', 'TELUS Translator'],
  ['/multi-language-translation', 'Multi Language Translation'],
  ['/releases', 'Releases'],
  ['/turbopuffer-explorer', 'Turbopuffer Explorer'],
  ['/metadataSearchTool', 'TELUS Enterprise Metadata Search'],
];

// Pages that set document.title themselves (the Backstage scaffolder, via Helmet).
const SELF_TITLED_PATHS = ['/create'];

/** The title for `pathname`, or undefined where the page owns its title. */
export const pageTitleFor = (pathname: string): string | undefined => {
  const matches = (path: string) => matchPath({ path, end: false }, pathname);
  if (SELF_TITLED_PATHS.some(matches)) return undefined;
  return PAGE_TITLES.find(([path]) => matches(path))?.[1] ?? DEFAULT_TITLE;
};
